import FetchRequest from "@/api/FetchRequest";
class changeSoundApi {
    // 基础url
    static url = "/ai/voice/change/history/";
    // 查询变声角色
    static getList(pageNum:number,pageSize:number): Promise<any> {
        return FetchRequest.get(this.url + 'list'+'?pageNum='+pageNum+'&pageSize='+pageSize  ,true );
    }
    // 新增变声
    static addChange(roleId:string,originalFileId:string,param:any,targetFolderId:string): Promise<any> {
        const data={
            roleId:roleId,
            originalFileId:originalFileId,
            param:param,
            targetFolderId:targetFolderId
        }
        return FetchRequest.post(this.url ,JSON.stringify(data) , true);
    }
    //删除
     static delChange(ids: string): Promise<any> {
        return FetchRequest.del(this.url +ids,'' , true);
    }

}
export default changeSoundApi;